import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import _ from 'lodash';
import { Link } from "react-router";

import {
    MenuTree, MenuItem
} from '../../../common/components/layout';

import { verifyPermission } from '../../../helpers/verifyPermission';
import { menuPermissions } from './permissions';
// import { connect } from 'react-redux'

class MenuUsers extends Component {
    items = menuPermissions;

    toggleModal = (show=null) => {
        this.props.togglMenu(false);
        this.props.toggleModal(show);
    }

    closeMenu = () => {
        this.props.togglMenu(false);
    }

    renderMenu() {
        return this.items.map((item, index) => {
            if (_.isUndefined(item.type)) {
                if (verifyPermission(item.permissions, null)) {
                    return <MenuItem key={index} path={item.path} label={item.label} icon={item.icon} color="white" closeMenu={this.closeMenu} />
                }
                return null
            }
            else {
                const menuTree = item.items.map((i, index2) => {

                    if (verifyPermission(i.permissions, null)) {
                        return <MenuItem path={i.path} label={i.label} icon={i.icon} color="white" closeMenu={this.closeMenu} />
                    }
                    return null
                });

                if (menuTree.filter((item) => item !== null).length > 0) {
                    return (
                        <MenuTree icon={item.icon} label={item.label} color="white">
                            {menuTree}
                        </MenuTree>
                    )
                }
                else {
                    return null
                }

            }
        })
    }

    render() {
        return (
            <ul className="sidebar-menu">
                <li style={{paddingTop: 10, paddingBottom: 10, paddingLeft: 15, display: 'flex', alignContent: 'center', alignItems: 'center', justifyContent: 'center'}}>
                    <span style={{color: 'white', fontSize: '1.8rem', flex: 8}}>Menu</span>
                    <i className="fa fa-bars" style={{fontSize: '2rem', color: 'white', flex: 1, cursor: 'pointer'}} onClick={this.closeMenu}></i>
                </li>
                {this.props.auth.user.is_admin ?
                <li>
                    <Link to='/admin'>
                        <i className='icon-dashboard' style={{ color: 'white', margin: 0, marginLeft: -5, fontSize: 25 }} />
                        <span style={{verticalAlign: 'super', fontSize: '1.6rem', color: 'white'}}>&nbsp;&nbsp;Administração</span>
                    </Link>
                </li>
                : null
                }

                {this.renderMenu()}
                <li onClick={this.toggleModal}>
                    <a href={window.location.href}>
                        <i className='icon-turn-off' style={{ color: 'white', margin: 0, marginLeft: -5, fontSize: 25 }} />
                        <span style={{verticalAlign: 'super', fontSize: '1.6rem', color: 'white'}}>&nbsp;&nbsp;Sair</span>
                    </a>
                </li>
            </ul >
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
            
        },
        dispatch
    )
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuUsers);